import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import AddVehicleTile from './AddVehicleTile'
import { changeVehicleSelectorField } from './actions'
import { showNewShopTiresModal } from '../../NewShopTiresModal/actions'
import { YMME_NAME } from 'constant'

const withAddVehicleTileHandlers = withHandlers({
  onClick: ({ showNewShopTiresModal }) => () => {
    showNewShopTiresModal({
      isOnlyVehicle: true,
      ymmeName: YMME_NAME,
      skipTireSizeExperience: true
    })
  }
})

export default compose(
  connect(null, { changeVehicleSelectorField, showNewShopTiresModal }),
  withAddVehicleTileHandlers
)(AddVehicleTile)
